import React from 'react';
import { useForm, useWatch } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { Button } from '@material-ui/core';
import CompanyHelper from '../../../../@types/model/masterData/company';
import { ICompanyFormValues } from '../../../../@types/model/masterData/company/CompanyFormValues';
import CustomLabelledCheckBox from '../../../customComponentV2/input/CustomCheckBox';
import CustomControlledTextField from '../../../customComponentV2/input/CustomControlledTextField';

interface ICompanyEditFormProps {
    initialValues : ICompanyFormValues;
    onSubmit : (values : ICompanyFormValues) => void;
    onCancel : () => void;
}

const CompanyEditForm = (props : ICompanyEditFormProps) : React.ReactElement => {
    const schema = CompanyHelper.formSchema();
    

    const { handleSubmit, control, formState: { isValid, isDirty } } = useForm<ICompanyFormValues>({
        defaultValues: props.initialValues,
        resolver: yupResolver(schema),
        mode: 'onChange',
    });

    const isPaymentEnabled = useWatch({ control, name: 'paymentEnabled' });

    return (
        <>
            <form onSubmit={handleSubmit(props.onSubmit)}>
                <div className={'fdc p30 pt15 pb0'}>
                    <div className={'fdc wfill pt10 mb20'}>
                        <div className={'wfill mb15'}>
                            <CustomControlledTextField 
                                className={'wfill'}
                                label={'Code'}
                                name={'code'}
                                control={control}
                            />
                        </div>
                        <div className={'wfill mb15'}>
                            <CustomControlledTextField 
                                className={'wfill'}
                                label={'Name'}
                                name={'name'}
                                control={control}
                            />
                        </div>
                        <div className='jcfs aifs mb15'>
                            <CustomLabelledCheckBox 
                                name={'paymentEnabled'}
                                label={'Payment Enabled'}
                                control={control}
                                defaultValue={props.initialValues.paymentEnabled}
                            />
                        </div>
                        {
                            isPaymentEnabled &&
                            <>
                                <div className={'wfill mb15'}>
                                    <CustomControlledTextField 
                                        className={'wfill'}
                                        label={'VAT GL Account'}
                                        name={'vatAccountNumber'}
                                        control={control}
                                        disabled={!isPaymentEnabled}

                                    />
                                </div>
                                <div className={'wfill mb15'}>
                                    <CustomControlledTextField 
                                        className={'wfill'}
                                        label={'Electricity GL Account'}
                                        name={'electricityAccountNumber'}
                                        control={control}
                                        disabled={!isPaymentEnabled}

                                    />
                                </div>
                                <div className={'wfill mb15'}>
                                    <CustomControlledTextField 
                                        className={'wfill'}
                                        label={'Interest GL Account'}
                                        name={'interestAccountNumber'}
                                        control={control}
                                        disabled={!isPaymentEnabled}
                                    />
                                </div>
                            </>
                        }
                        
                    </div>
                    <div className='flx1 fdr jcfs'>
                        <CustomLabelledCheckBox 
                            name={'isActive'}
                            label={'Is Active'}
                            control={control}
                            defaultValue={props.initialValues.isActive}
                            disabled={props.initialValues.isActive}
                        />
                    </div>
                    <div className={'fdr flx1 aic jcfe mb20'}>
                        <div className={'jcfe'}>
                            <Button className='m10' disabled={!isValid || !isDirty} type='submit' variant='contained' color='primary'>
                                OK
                            </Button>
                            <Button className='m10' variant='outlined' onClick={props.onCancel} color='primary' autoFocus>
                                CANCEL
                            </Button>
                        </div>
                    </div>
                </div>
            </form>
        </>
    );
};

export default CompanyEditForm;